// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.CreateBlogPost_create-blog-container__guD-0 {
  padding: 0;
  margin: 0;
}

.CreateBlogPost_create-blog-form__X09ku {
  width: 100%;
}

.CreateBlogPost_form-card__aHiuI {
  margin-top: 24px;
  background-color: #fff;
  border: 1px solid white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
@media (max-width: 768px) {
  .CreateBlogPost_form-card__aHiuI {
    padding: 20px;
    gap: 20px;
  }
}

.CreateBlogPost_form-field__nJQV4 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.CreateBlogPost_field-label__FwlkJ {
  font-size: 0.9rem;
  color: #82B194;
  font-weight: 700;
  text-transform: uppercase;
}

.CreateBlogPost_error-message__IgHpX {
  background-color: #fee2e2;
  color: #b91c1c;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #fecaca;
  font-size: 0.9rem;
  font-weight: 500;
}

.CreateBlogPost_form-actions__qQ46X {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 10px;
  padding-top: 20px;
  border-top: 1px solid white;
}
@media (max-width: 600px) {
  .CreateBlogPost_form-actions__qQ46X {
    flex-direction: column-reverse;
  }
  .CreateBlogPost_form-actions__qQ46X button {
    width: 100%;
  }
}

.CreateBlogPost_section-divider__sVajG {
  height: 1px;
  background-color: white;
  margin: 10px 0;
}

.CreateBlogPost_section-title__kox9A {
  font-size: 1.2rem;
  color: #82B194;
  margin: 0;
}

.CreateBlogPost_dynamic-list__YWJOe {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.CreateBlogPost_list-item__7XRkq {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px 56px 20px 20px;
  background-color: white;
  border-radius: 16px;
  border: 1px solid white;
  position: relative;
}

.CreateBlogPost_add-button__dy-qj {
  align-self: flex-start;
}

.CreateBlogPost_delete-btn__N6PrJ {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: 1px solid rgba(201, 92, 92, 0.4);
  background: #FEF2F2;
  color: #C95C5C;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
}
.CreateBlogPost_delete-btn__N6PrJ:hover {
  background: #C95C5C;
  color: #fff;
  border-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/pages/Blog/CreateBlogPost/CreateBlogPost.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACE,UAAA;EACA,SAAA;AAiBF;;AAdA;EACE,WAAA;AAiBF;;AAdA;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBDiCc;EChCd,0CAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAiBF;AAfE;EAXF;IAYI,aAAA;IACA,SAAA;EAkBF;AACF;;AAfA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAkBF;;AAfA;EACE,iBAAA;EACA,cDzBqB;EC0BrB,gBAAA;EACA,yBAAA;AAkBF;;AAfA;EACE,yBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAkBF;;AAfA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AAkBF;AAhBE;EARF;IASI,8BAAA;EAmBF;EAjBE;IACE,WAAA;EAmBJ;AACF;;AAfA;EACE,WAAA;EACA,uBAAA;EACA,cAAA;AAkBF;;AAfA;EACE,iBAAA;EACA,cDjEqB;ECkErB,SAAA;AAkBF;;AAfA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAkBF;;AAfA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,4BAAA;EACA,uBAAA;EACA,mBD5Cc;EC6Cd,uBAAA;EACA,kBAAA;AAkBF;;AAfA;EACE,sBAAA;AAkBF;;AAfA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,UAAA;AAkBF;AAhBE;EAAU,mBAAA;EAAqB,WAAA;EAAa,yBAAA;AAqB9C","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n.create-blog-container {\n  padding: 0;\n  margin: 0;\n}\n\n.create-blog-form {\n  width: 100%;\n}\n\n.form-card {\n  margin-top: 24px;\n  background-color: #fff;\n  border: 1px solid lighten($color-primary, 40%);\n  border-radius: $border-radius;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  @media (max-width: 768px) {\n    padding: 20px;\n    gap: 20px;\n  }\n}\n\n.form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.field-label {\n  font-size: 0.9rem;\n  color: $color-primary;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.error-message {\n  background-color: #fee2e2;\n  color: #b91c1c;\n  padding: 1rem;\n  border-radius: 8px;\n  border: 1px solid #fecaca;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  margin-top: 10px;\n  padding-top: 20px;\n  border-top: 1px solid lighten($color-primary, 45%);\n\n  @media (max-width: 600px) {\n    flex-direction: column-reverse;\n\n    button {\n      width: 100%;\n    }\n  }\n}\n\n.section-divider {\n  height: 1px;\n  background-color: lighten($color-primary, 45%);\n  margin: 10px 0;\n}\n\n.section-title {\n  font-size: 1.2rem;\n  color: $color-primary;\n  margin: 0;\n}\n\n.dynamic-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.list-item {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  padding: 20px 56px 20px 20px;\n  background-color: lighten($color-primary, 48%);\n  border-radius: $border-radius;\n  border: 1px solid lighten($color-primary, 45%);\n  position: relative;\n}\n\n.add-button {\n  align-self: flex-start;\n}\n\n.delete-btn {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  border: 1px solid rgba(201, 92, 92, 0.4);\n  background: #FEF2F2;\n  color: #C95C5C;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  padding: 0;\n\n  &:hover { background: #C95C5C; color: #fff; border-color: transparent; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"create-blog-container": `CreateBlogPost_create-blog-container__guD-0`,
	"create-blog-form": `CreateBlogPost_create-blog-form__X09ku`,
	"form-card": `CreateBlogPost_form-card__aHiuI`,
	"form-field": `CreateBlogPost_form-field__nJQV4`,
	"field-label": `CreateBlogPost_field-label__FwlkJ`,
	"error-message": `CreateBlogPost_error-message__IgHpX`,
	"form-actions": `CreateBlogPost_form-actions__qQ46X`,
	"section-divider": `CreateBlogPost_section-divider__sVajG`,
	"section-title": `CreateBlogPost_section-title__kox9A`,
	"dynamic-list": `CreateBlogPost_dynamic-list__YWJOe`,
	"list-item": `CreateBlogPost_list-item__7XRkq`,
	"add-button": `CreateBlogPost_add-button__dy-qj`,
	"delete-btn": `CreateBlogPost_delete-btn__N6PrJ`
};
export default ___CSS_LOADER_EXPORT___;
